import { render, staticRenderFns } from "./ContadorBlog.vue?vue&type=template&id=265dda3e"
import script from "./ContadorBlog.vue?vue&type=script&lang=js"
export * from "./ContadorBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports